// extracted by mini-css-extract-plugin
export var body = "_m9-0";
export var sectionHeader = "_m9-4";
export var shortcutColumns = "_m9-2";
export var shortcutList = "_m9-1";
export var shortcutSection = "_m9-3";